/**
 * iOS「ホーム画面に追加」モーダルの「今後表示しない」設定を localStorage で永続化する。
 *
 * issue #29 Phase B: cookie → localStorage 移行。
 * - 旧 cookie 名: omakase_unshi_a2h_hide ('1' or 未設定)
 * - 新 localStorage 名: omakase-unshi:a2h-hide ('1' or 未設定)
 * - migrateHidePrefFromCookie() を mount で 1 回呼ぶことで既存ユーザーの設定を保持
 */

export const STORAGE_KEY = 'omakase-unshi:a2h-hide';
const OLD_COOKIE_NAME = 'omakase_unshi_a2h_hide';

export function getHidePref(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setHidePref(value: boolean): void {
  try {
    if (value) {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) {
    console.warn('[addToHomePref] failed to set preference', e);
  }
}

/**
 * 旧 cookie 値を localStorage に転記して cookie を削除する。
 * 冪等: localStorage に既に値があれば上書きしない、 cookie は常に削除する。
 * mount 時に 1 回呼ぶ。
 */
export function migrateHidePrefFromCookie(): void {
  try {
    let cookieValue: string | null = null;
    const pairs = document.cookie.split(';');
    for (const pair of pairs) {
      const eqIdx = pair.indexOf('=');
      if (eqIdx < 0) continue;
      const name = pair.slice(0, eqIdx).trim();
      const value = pair.slice(eqIdx + 1).trim();
      if (name === OLD_COOKIE_NAME) {
        cookieValue = value;
        break;
      }
    }
    if (cookieValue === null) return;

    if (window.localStorage.getItem(STORAGE_KEY) === null && cookieValue === '1') {
      window.localStorage.setItem(STORAGE_KEY, '1');
    }

    const secureFlag = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${OLD_COOKIE_NAME}=; Max-Age=0; Path=/; SameSite=Lax${secureFlag}`;
  } catch (e) {
    console.warn('[addToHomePref] migration failed', e);
  }
}
